export default {
  headerContent: {
    title: 'Türkiye Sigorta Özel Sağlık Sigortası Fiyat Sorgulama',
    slogan: "Özel Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'ÖZEL SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türkiye Sigorta Özel Sağlık Sigortası',
    description: {
      title: 'Türkiye Sigorta Özel Sağlık Sigortası Nedir? ',
      content: [
        'Sağlık sigortası, sağlık bakımı için ödeme yapmanın bir yoludur.  Yaralandığınızda veya hastalandığınızda tıbbi hizmetlerin tüm masraflarını ödemekten sizi korur. Tıpkı araba sigortası veya ev sigortası gibi, bir plan seçersiniz ve her ay belirli bir oran veya prim ödemeyi kabul edersiniz. Karşılığında sağlık sigortanız, kapsanan tıbbi masraflarınızın bir kısmını ödemeyi kabul eder. Sağlık sigortanız tarafından yapılan ödemeler, genellikle doktorlar ve hastanelerle pazarlık ettikleri indirimlere dayanmaktadır.',
        'Özel sağlık sigortası, sigortalının kaza veya hastalık sonucu alması gereken tedavi masraflarını poliçe limitleri dahilinde karşılamaktadır. Türkiye Sigorta güvencesinde sunulan hizmetlerden yararlanmak için hemen fiyat teklifi isteyebilirsiniz.'
      ]
    },
    subContent: {
      title: 'Özel Sağlık Sigortası Nasıl Çalışır? ',
      content: [
        {
          paragraph:
            'Bir sağlık planının üyesi olduğunuzda, o planı da seçmiş olan bir grup kişi arasına katılıyorsunuz. Sigortacılar buna risk havuzu diyorlar çünkü bu kişiler arasında ilişkili risk miktarını ölçüyorlar. ',
          subList: null
        },
        {
          paragraph:
            'Bazı kişiler, sağlıkları iyi olmadığı ve pek çok tıbbi hizmeti kullanma olasılıkları yüksek olduğu için yüksek riskli sayılır. Diğerleri daha düşük risklidir çünkü sağlıklıdırlar. Ve kimsenin başına gelebilecek beklenmedik hastalıkları veya yaralanmaları da unutmayalım. ',
          subList: null
        },
        {
          paragraph:
            'Sağlık sigortası, planınızdaki herkes için toplu tıbbi harcamaları karşılamanın ne kadara mal olacağını tahmin etmek için çok sayıda hesaplama yapar. Planın her üyesi aylık bir oran veya prim öder. Sağlık bakımına ihtiyacınız olduğunda, siz ve sağlık sigortanız, kapsanan tıbbi masrafları paylaşırsınız. ',
          subList: null
        },
        {
          paragraph:
            'Planınız sizi özetler ve cepten maliyetlerinizi güvence altına alır. Bazı yıllar çok sayıda tıbbi hizmete ihtiyaç duyabilirsiniz, diğer yıllarda daha azına ihtiyacınız olabilir, ancak buna sahip olmanın asıl amacı, tıbbi hizmetlerin tüm maliyetini kendi başınıza ödemekten kaçınabilmenizdir. Tıbbi maliyetler son derece yüksekse, sağlık sigortanız zaman zaman oranları ayarlamak zorunda kalabilir.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Özel Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Özel Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Özel Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Özel Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Özel Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türkiye Sigorta Özel Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Türkiye Sigorta Özel Sağlık Sigortası Planları Nelerdir?',
      content: [
        {
          paragraph:
            'Çeşitli sağlık sigortası türleri vardır. Tıbbi sağlık sigortası, siz ve aileniz için özel bir sigortacı, bir işveren veya aynı zamanda limitli – limitsiz planlar sağlanabilir.',
          subList: null
        },
        {
          paragraph: 'Türkiye sigorta sigortalılarına 4 adet plan sunmaktadır.',
          subList: null
        },
        {
          paragraph: 'Bu planlar,',
          subList: [
            'Okyanus Avantaj Sağlık Sigortası',
            'Okyanus Ekstra Sağlık Sigortası',
            'Okyanus Limitli Sağlık Sigortası',
            'Okyanus Limitsiz Sağlık Sigortasından oluşmaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Özel Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta her plan için farklı teminatlar vermektedir.',
          subList: null
        },
        {
          paragraph: 'Aşağıdaki tabloda plan teminatlarına göz atabilirsiniz.',
          subList: null
        },
        {
          paragraph: 'TABLOO',
          subList: [
            'Yatarak tedavi teminatı; hastanede 24 saati aşan veya aşmayan yatış gerektiren tedavileri kapsamaktadır.',
            'Ayakta tedavi teminatı; hastanede 24 saati aşmayan tedavileri kapsamaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Özel Sağlık Sigortasına Neden İhtiyacım Var?',
      content: [
        {
          paragraph:
            'Çoğu insan, sağlık hizmetlerinin yüksek maliyetini tek başına üstlenmek istemez. İşte burada sağlık sigortası devreye girer. Her ay bir prim ödersiniz ve sigortacınız, kapsanan tıbbi masrafların bir kısmını öder. Sigortacı, doktorlardan ve hastanelerden daha iyi oranlar için pazarlık yapabilir. Bu nedenle, bir doktor ziyareti için cepten yüzlerce lira veya bir ameliyat için bütçe ödemek yerine, planınıza bağlı olarak daha az bir miktar ödersiniz.',
          subList: null
        },
        {
          paragraph:
            'Pek çok insan, sağlık sigortasını hastalandığında kullanılacak bir şey gibi düşünür, ancak bundan çok daha fazlasıdır. ',
          subList: null
        },
        {
          paragraph:
            'Planınızın sunduğu önleyici hizmetlerden yararlanabilirsiniz. Doktorunuzu kontroller için düzenli olarak ziyaret ederek ve önerilen taramaları alarak, daha sonra daha ciddi durumları önleme olasılığınız artar. Ayrıca birçok sağlık planı, sağlıklı yaşam programları ve sağlık ürünleri ve hizmetlerinde indirimler sunar.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Özel Sağlık Sigortası Doğumu Karşılıyor Mu?',
      content: [
        {
          paragraph:
            'Satın almış olduğunuz plana göre doğum teminatı değişmektedir. Detaylı bilgi için uzman danışmanızla iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Özel Sağlık Sigortası Doğumu Teminatı Yaş Sınırı Nedir?',
      content: [
        {
          paragraph:
            'Doğum teminatı alına bilmesi için sigortalının yaşı 18-45 yaş arası olması gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigortadan Sadece Doğumu Teminatı Alabilir Miyim?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası kapsamında sadece doğum teminatı verilmemektedir. Yalnız demir sigortadan doğum sigortası alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Özel Sağlık Sigortası Doğumu Bekleme Süresi Ne Kadar?',
      content: [
        {
          paragraph:
            'Doğum teminatından yararlana bilmek için poliçe başlangıcından itibaren 12 ay geçmesi gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Özel Sağlık Sigortası Kimler Yaptırabilir?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta’nın sunmuş olduğu özel sağlık sigortasını 0-59 yaş arası olan tüm kişiler yaptırabilir.',
          subList: null
        },
        {
          paragraph:
            'Bir sağlık sigortası poliçesi, kazalar, hastalıklar veya yaralanmalar nedeniyle ortaya çıkan tıbbi harcamalara karşı kapsamı genişletir. Birey, belirli bir görev süresi için aylık veya yıllık prim ödemelerine karşı böyle bir politikadan yararlanabilir. Bu süre içerisinde sigortalı bir kaza ile karşılaşırsa veya ağır bir rahatsızlık teşhisi konulursa tedavi amaçlı yapılan masraflar sigorta şirketi tarafından karşılanır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Sağlık Sigortama Eşimi Ve Çocuklarımı Dahil Ettirebilir Miyim?',
      content: [
        {
          paragraph:
            'Mevcutta bulunan sigortanıza eşinizi ve çocuklarınızı yenileme döneminde ekletebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Özel Sağlık Sigortası Yurt Dışında Kullanabilir Miyim?',
      content: [
        {
          paragraph:
            'Yalnızca poliçeye yurt dışı teminatı eklenmesi durumunda yurt dışında kullanılması mümkündür.',
          subList: null
        }
      ]
    },
    {
      title: 'Sigorta Özel Sağlık Sigortası Diyetisyeni Karşılıyor Mu?',
      content: [
        {
          paragraph:
            'Ek hizmetler kapsamında yıllık bir defaya mahsus olmak kaydıyla sunulmaktadır. ',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Özel Sağlık Sigortası Geçerlilik Süresi Ne Kadardır?',
      content: [
        {
          paragraph:
            'Poliçe geçerlilik süresi poliçe başlangıç tarihinden itibaren 1 yıldır. Poliçe 1 yılın sonunda yenilenmemesi durumunda hastanelerden alınmış olan tedaviler karşılanmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Sağlık Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası, başvuru formunun doldurulması ardından şirkete gönderilir, şirket tarafından yapılan risk değerlendirme sonucu fiyat belirlenir. Özel sağlık sigortası kişiye özel olarak hazırlanmakta olup fiyatlar değişkenlik gösterebilmektedir.',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortası almak isteyen müşterilerimiz Alokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan sağlık uzmanı danışmanımızla iletişime geçerek özel sağlık sigortası hakkında detaylı bilgi talep edebilir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Özel Sağlık Sigortası Ne Kadar?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası fiyatları alınmış olan teminata, network seçimlerine, sigortalının özelliklerine ve şirket politikalarına göre değişmektedir.',
          subList: null
        },
        {
          paragraph:
            'Size özel hazırlanmış teklifi değerlendirmek ve poliçe tanzimi gerçekleştirmek için Alokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan sağlık uzmanı danışmanımızla iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
